import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class RunNetworkDiscoveryValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  public canRunOnMultipleCompanies = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    // this action is disabled on all folders / groups
    if (!ProtectedEntitiesHelper.isEndpoint(record)) {
      return false;
    }

    if (record.specifics.serverHasNsxIntegration) {
      return false;
    }

    const { specifics } = record;

    if (!specifics.isManaged) {
      return false;
    }

    if (!specifics.appId) {
      return false;
    }

    const winAcceptedAppIds = [
      Constants.Endpoints.APP_IDS.APPID_EP_CLIENT,
      Constants.Endpoints.APP_IDS.APPID_UNIFIED_CLIENT,
      Constants.Endpoints.APP_IDS.APPID_SCANDINAVIA_CLIENT,
    ];

    const allowExtraValidationsCondition =
      (specifics.operatingSystem === Constants.ProtectedEntities.OS.PROTECTED_ENTITY_OS_WIN &&
        winAcceptedAppIds.indexOf(specifics.appId) !== -1) ||
      (specifics.operatingSystem === Constants.ProtectedEntities.OS.PROTECTED_ENTITY_OS_NIX &&
        specifics.appId === Constants.Endpoints.APP_IDS.APPID_UNIFIED_CLIENT);

    if (!allowExtraValidationsCondition) {
      return false;
    }

    if (specifics.appId === Constants.Endpoints.APP_IDS.APPID_VMWARE_SERVER) {
      return false;
    }

    if (specifics.appId === Constants.Endpoints.APP_IDS.APPID_SCANDINAVIA_SERVER) {
      return false;
    }

    if (specifics.appId === Constants.Endpoints.APP_IDS.APPID_HVINTRO_SERVER) {
      return false;
    }

    if (specifics.appId === Constants.Endpoints.APP_IDS.APPID_VSHIELD_CLIENT) {
      return false;
    }

    return true;
  }
}
